import { AppName } from 'src/global/globalConfig';
import analyticsTracking from 'src/services/analytics-service';
import { AnalyticsOptions } from 'src/shared/helpers/analyticsHelper';
import useProject from 'src/shared/hooks/useProject';

export type UpgradeSubscriptionSections = 'page_top' | 'filter_tooltip' | 'focus_popup' | 'sample_overview' | 'species_info_popup';
const useSpeciesMapAnalytics = () => {
    const { currentProjectDetails } = useProject();

    const sendTrackEvent = (ga: AnalyticsOptions) => {
        analyticsTracking.trackEvent({
            ...ga,
            project: currentProjectDetails?.projectName,
        });
    };

    const trackUpgradeSubscriptionClick = (props: { section: UpgradeSubscriptionSections }) => {
        sendTrackEvent({
            action: `upgrade_subscription_click_from_map_${props.section}`,
            category: 'upgrade-subscription-link',
            app: AppName.MAP,
        });
    };

    const trackDownloadImageClick = () => {
        sendTrackEvent({
            action: 'species_map_download_image_click',
            category: 'species-map',
            app: AppName.MAP,
        });
    };

    const trackShareClick = (props: { type: 'starter' | 'species_insights' }) => {
        sendTrackEvent({
            action: `species_map_share_click_for_${props.type}`,
            category: 'share-project',
            app: AppName.MAP,
        });
    };

    return {
        trackUpgradeSubscriptionClick,
        trackDownloadImageClick,
        trackShareClick,
    };
};

export default useSpeciesMapAnalytics;
